import { createIcon } from '@chakra-ui/react';

export const CriticalBatteryIcon = createIcon({
  displayName: 'CriticalBatteryIcon',
  viewBox: '0 0 24 24',
  defaultProps: { fill: 'none', width: '24', height: '24' },
  path: (
    <path
      d="M19.9717 6.84515C20.8419 6.84527 21.5479 7.55103 21.5479 8.42133V9.80023C21.5728 9.79888 21.5978 9.79731 21.623 9.7973C22.3833 9.7973 23 10.414 23 11.1743V12.8256C23 13.5859 22.3833 14.2026 21.623 14.2026C21.5978 14.2026 21.5728 14.2 21.5479 14.1987V15.5795C21.5476 16.4496 20.8418 17.1556 19.9717 17.1557H2.90234C2.03213 17.1557 1.32643 16.4497 1.32617 15.5795V8.42133C1.32617 7.55095 2.03197 6.84515 2.90234 6.84515H19.9717ZM2.90234 8.34515C2.8604 8.34515 2.82617 8.37938 2.82617 8.42133V15.5795C2.82643 15.6213 2.86056 15.6557 2.90234 15.6557H19.9717C20.0134 15.6556 20.0476 15.6212 20.0479 15.5795V8.42133C20.0479 8.37946 20.0135 8.34528 19.9717 8.34515H2.90234ZM5.93066 14.2026H4.27832V9.7973H5.93066V14.2026Z"
      fill="#EF4E4E"
      fillRule="evenodd"
    />
  ),
});
